<script>
import mixin from "@/pages/inspection_reports/forms/mixin";
import {router} from "@inertiajs/vue3";
import kvalues from "@/pages/inspection_reports/forms/kvalues";

export default {
	mixins: [mixin],
  props: {
    cylinders: {
      required: true,
    }
  },
  mounted() {
    this.CylindersAreBoundToUser(this.cylinders);
  },
	methods: {
    async CylindersAreBoundToUser(cylinders) {
      let manufactureType = this.customerProduct.product.manufacture.name;
      let requiredTypes = [];

      if(manufactureType === 'Capelec') {
        requiredTypes = ['kvalues_calfilter2'];
      } else {
        requiredTypes = ['kvalues_calfilter1', 'kvalues_calfilter2', 'kvalues_calfilter3'];
      }


      let missingTypes = requiredTypes.filter(type => !cylinders.some(cylinder => cylinder.type === type));

      if (missingTypes.length > 0) {
        let confirmed = await Helpers.Alert.confirm('De benodigde cylinders zijn niet gekoppeld aan deze technicus');
        if (confirmed || !confirmed) {
          router.visit(route('cylinders.index'));
          return;
        }
      }

      return true;
    },
		getGroups() {
      let manufactureType = this.customerProduct.product.manufacture.name;
      let measurementValues = {};

      if(manufactureType === 'Capelec') {
        let cilinder2 = this.getCylinder('kvalues_calfilter2');

        measurementValues = {
          'kvalues_calfilter2': this.input({type: 'YesNoCalculateKValueForms', label: `Cal.filter2 ${cilinder2.custom_value} %`, value: this.getValue('kvalues_calfilter2'), cylinders: this.cylinders, callback: kvalues}),
        }
      } else {
        let cilinder1 = this.getCylinder('kvalues_calfilter1');
        let cilinder2 = this.getCylinder('kvalues_calfilter2');
        let cilinder3 = this.getCylinder('kvalues_calfilter3');

        measurementValues = {
          'kvalues_calfilter1': this.input({type: 'YesNoCalculateKValueForms', label: `Cal.filter1 ${cilinder1.custom_value} %`, value: this.getValue('kvalues_calfilter1'), cylinders: this.cylinders, callback: kvalues}),
          'kvalues_calfilter2': this.input({type: 'YesNoCalculateKValueForms', label: `Cal.filter2 ${cilinder2.custom_value} %`, value: this.getValue('kvalues_calfilter2'), cylinders: this.cylinders, callback: kvalues}),
          'kvalues_calfilter3': this.input({type: 'YesNoCalculateKValueForms', label: `Cal.filter3 ${cilinder3.custom_value} %`, value: this.getValue('kvalues_calfilter3'), cylinders: this.cylinders, callback: kvalues}),
        }
      }

			return [
				{
          'title': 'Algemene gegevens',
					'name': 'product',
					'component': 'default',
					'values': {
						'product_manufacturer': this.input({type: 'Default', label: 'Fabrikaat', value: this.getValue('product_manufacturer', this.customerProduct.product.manufacture.name)}),
						'product_type': this.input({type: 'Default', label: 'Type', value: this.getValue('product_type', this.customerProduct.product.type.name)}),
            'product_serie_nr': this.input({type: 'Default', label: 'Serienr.', value: this.getValue('product_serie_nr', this.customerProduct.product.serial_number)}),
						'product_toelatingsnr': this.input({type: 'Default', label: 'Toelatingsnr', value: this.getValue('product_toelatingsnr', this.customerProduct.product.type_approval_number)}),
					}
				},
				{
					'title': 'Plaats van opstelling',
					'name': 'customer',
          'component': 'hidden',
					'values': {
						'customer_naam': this.input({type: 'Default', label: 'Naam', value: this.getValue('customer_naam', this.customerProduct.customer.name)}),
						'customer_adres': this.input({type: 'Default', label: 'Adres', value: this.getValue('customer_adres', this.customerProduct.customer.address)}),
						'customer_plaats': this.input({type: 'Default', label: 'Plaats', value: this.getValue('customer_plaats', this.customerProduct.customer.city)}),
					}
				},
        {
          'title': 'Conformiteit',
          'name': 'conformiteit',
          'component': 'default',
          'values': {
            'conformiteit_software_versie': this.input({type: 'YesNo', label: `Softwareversie : ${this.softwareVersion}`, value: this.getValue('conformiteit_software_versie')}),
            'conformiteit_checksum': this.input({type: 'YesNo', label: `Checksum : ${this.checksum}`, value: this.getValue('conformiteit_checksum')}),
            'conformiteit_aanwijsinrichting': this.input({type: 'Default', label: `Aanwijsinrichting: ${this.aanwijsinrichting}`, value: this.getValue('conformiteit_aanwijsinrichting')}),
            'conformiteit_tellerstand': this.input({type: 'Default', label: 'Tellerstand voor / na / n.v.t', value: this.getValue('conformiteit_tellerstand')}),
            'conformiteit_uitlaatsondes': this.input({type: 'YesNo', label: 'Uitlaatsonde(s) conform toel.', value: this.getValue('conformiteit_uitlaatsondes')}),
            'conformiteit_werking': this.input({type: 'Default', label: 'Werking printer en afdruk (toelating en serienr.)', value: this.getValue('conformiteit_werking')}),
            'conformiteit_dynamische_test': this.input({type: 'Default', label: 'Dynamische test', value: this.getValue('conformiteit_dynamische_test')}),
          }
        },
        {
          'title': 'Algemeen',
          'name': 'common',
          'component': 'default',
          'values': {
            'common_verzegeling_onbeschadigd': this.input({type: 'YesNo', label: 'Verzegeling onbeschadigd', value: this.getValue('common_verzegeling_onbeschadigd')}),
            'common_omgevingstemperatuur': this.input({type: 'YesNo', label: 'Omgevingstemperatuur +5 tot 40 °C', value: this.getValue('common_omgevingstemperatuur')}),
            'common_nl_handleiding': this.input({type: 'YesNo', label: 'NL handleiding en NL opschriften', value: this.getValue('common_nl_handleiding')}),
            'common_opschriften': this.input({type: 'YesNo', label: 'NL opschriften / conformiteit', value: this.getValue('common_opschriften')}),
            'common_parts': this.input({type: 'YesNo', label: 'Alle losse onderdelen aanwezig', value: this.getValue('common_parts')}),
            'common_voeding': this.input({type: 'YesNo', label: 'Voedingsspanning', value: this.getValue('common_voeding')}),
            'common_electronische_mechanische_werking': this.input({type: 'YesNo', label: 'Electronische / mechanische werking', value: this.getValue('common_electronische_mechanische_werking')}),
            'common_optische_controle': this.input({type: 'YesNo', label: 'Optische controle olietemp. / rpm opnemer / slangen', value: this.getValue('common_optische_controle')}),
          }
        },
        {
          'title': 'Metingen',
          'name': 'measurement',
          'component': 'default',
        	'values': measurementValues,
        },
        {
          'title': 'Omschrijving',
          'name': 'slot',
          'component': 'default',
          'values': {
            'slot_notes': this.input({type: 'textarea', label: 'Opmerkingen', value: this.getValue('common_notes')}),
          }
        }
			]
		}
	}
}
</script>

<template>
	<FormRenderer
		ref="renderer"
		:inspectionReport="inspectionReport"
		:inspectionReportResponse="inspectionReportResponse"
		:customerProduct="customerProduct"
		:appointmentId="appointmentId"
	/>
</template>